/* B2B Catalog — layout switcher + variant picker */
(function () {
  'use strict';

  function initB2BCatalog(section) {
    var content = section.querySelector('[data-section-id] .b2b-catalog__content, .b2b-catalog__content');
    if (!content) return;

    var defaultView = content.getAttribute('data-default-view') || 'table';
    setView(content, defaultView);

    var viewBtns = section.querySelectorAll('.b2b-view-btn');
    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view');
        if (!view) return;
        setView(content, view);
        viewBtns.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-view') === view);
          b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false');
        });
      });
    });

    var variantPickers = section.querySelectorAll('.b2b-variant-picker');
    variantPickers.forEach(function (picker) {
      picker.addEventListener('change', function () {
        var selected = picker.options[picker.selectedIndex];
        if (!selected) return;
        var row = picker.closest('.b2b-catalog__row--product');
        if (!row) return;
        var skuEl = row.querySelector('.b2b-catalog__sku');
        var priceEl = row.querySelector('.b2b-catalog__price');
        if (skuEl && selected.dataset.sku !== undefined) {
          skuEl.textContent = selected.dataset.sku || '\u2014';
        }
        if (priceEl && selected.dataset.price !== undefined) {
          priceEl.textContent = selected.dataset.price || '';
        }
      });
    });
  }

  function setView(content, view) {
    content.setAttribute('data-active-view', view);
  }

  function init() {
    var sections = document.querySelectorAll('.b2b-catalog');
    sections.forEach(function (section) {
      initB2BCatalog(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
